'use client';
import React, { useRef } from 'react';
import Navbar from '@/components/Navbar';
import HeroSection from '@/components/HeroSection';
import TrustBar from '@/components/TrustBar';
import AboutSection from '@/components/AboutSection';
import ServicesSection from '@/components/ServicesSection';
import WhyChooseUs from '@/components/WhyChooseUs';
import CTABanner from '@/components/CTABanner';
import FAQSection from '@/components/FAQSection';
import ContactSection from '@/components/ContactSection';
import Footer from '@/components/Footer';

export default function HomePage() {
  const contactRef = useRef<HTMLDivElement>(null);
  const servicesRef = useRef<HTMLDivElement>(null);

  const scrollToContact = () => {
    const el = document.getElementById('contact');
    if (el) el?.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToServices = () => {
    const el = document.getElementById('services');
    if (el) el?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <main data-component-id="src/app/page.tsx:29:4" data-component-path="src/app/page.tsx" data-component-line="29" data-component-end-line="59" data-component-file="page.tsx" data-component-name="main" data-component-content="%7B%22elementName%22%3A%22main%22%2C%22className%22%3A%22font-mulish%20bg-secondary%22%7D" className="font-mulish bg-secondary">
      {/* Sticky Navigation */}
      <Navbar data-component-id="src/app/page.tsx:31:6" data-component-path="src/app/page.tsx" data-component-line="31" data-component-end-line="31" data-component-file="page.tsx" data-component-name="Navbar" data-component-content="%7B%22elementName%22%3A%22Navbar%22%7D" />

      {/* Hero Section */}
      <HeroSection data-component-id="src/app/page.tsx:34:6" data-component-path="src/app/page.tsx" data-component-line="34" data-component-end-line="34" data-component-file="page.tsx" data-component-name="HeroSection" data-component-content="%7B%22elementName%22%3A%22HeroSection%22%7D" onBookService={scrollToContact} onContact={scrollToContact} />

      {/* Trust/Stats Bar */}
      <TrustBar data-component-id="src/app/page.tsx:37:6" data-component-path="src/app/page.tsx" data-component-line="37" data-component-end-line="37" data-component-file="page.tsx" data-component-name="TrustBar" data-component-content="%7B%22elementName%22%3A%22TrustBar%22%7D" />

      {/* About Section */}
      <AboutSection data-component-id="src/app/page.tsx:40:6" data-component-path="src/app/page.tsx" data-component-line="40" data-component-end-line="40" data-component-file="page.tsx" data-component-name="AboutSection" data-component-content="%7B%22elementName%22%3A%22AboutSection%22%7D" />

      {/* Services Section */}
      <ServicesSection data-component-id="src/app/page.tsx:43:6" data-component-path="src/app/page.tsx" data-component-line="43" data-component-end-line="43" data-component-file="page.tsx" data-component-name="ServicesSection" data-component-content="%7B%22elementName%22%3A%22ServicesSection%22%7D" />

      {/* Why Choose Us */}
      <WhyChooseUs data-component-id="src/app/page.tsx:46:6" data-component-path="src/app/page.tsx" data-component-line="46" data-component-end-line="46" data-component-file="page.tsx" data-component-name="WhyChooseUs" data-component-content="%7B%22elementName%22%3A%22WhyChooseUs%22%7D" />

      {/* Mid-page CTA Banner */}
      <CTABanner data-component-id="src/app/page.tsx:49:6" data-component-path="src/app/page.tsx" data-component-line="49" data-component-end-line="49" data-component-file="page.tsx" data-component-name="CTABanner" data-component-content="%7B%22elementName%22%3A%22CTABanner%22%7D" onBookService={scrollToContact} />

      {/* FAQ Section */}
      <FAQSection data-component-id="src/app/page.tsx:52:6" data-component-path="src/app/page.tsx" data-component-line="52" data-component-end-line="52" data-component-file="page.tsx" data-component-name="FAQSection" data-component-content="%7B%22elementName%22%3A%22FAQSection%22%7D" />

      {/* Contact & Service Request Form */}
      <ContactSection data-component-id="src/app/page.tsx:55:6" data-component-path="src/app/page.tsx" data-component-line="55" data-component-end-line="55" data-component-file="page.tsx" data-component-name="ContactSection" data-component-content="%7B%22elementName%22%3A%22ContactSection%22%7D" />

      {/* Footer */}
      <Footer data-component-id="src/app/page.tsx:58:6" data-component-path="src/app/page.tsx" data-component-line="58" data-component-end-line="58" data-component-file="page.tsx" data-component-name="Footer" data-component-content="%7B%22elementName%22%3A%22Footer%22%7D" />
    </main>
  );
}
